'use client';

import type { ReactNode } from 'react';

import { OrganizationMembers } from '../../components/OrganizationProfile/OrganizationMembers';

export const OrganizationProfileMembersPanel = (): ReactNode => <OrganizationMembers />;
